import { useEffect } from "react";
import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { InputCheck } from "../../Atoms/Inputs/InputCheck";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useProfilesRegister } from "./useProfilesRegister";

export const ProfilesRegisterTemplate = () => {
  const {
    handleSubmit,
    register,
    handleChangeItem,
    handleSubmitForm,
    recursos,
    fields,
  } = useProfilesRegister();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Cadastro de Perfis</Title>

        <S.Form onSubmit={handleSubmit(handleSubmitForm)}>
          <div>
            <Input {...register("nome")} label="Nome" required id="nome" />
          </div>

          <div>
            <p>Recursos</p>
          </div>

          <div>
            {recursos?.length > 0 &&
              recursos.map((i) => (
                <InputCheck
                  checked={fields?.some((r) => r.value === i)}
                  key={Math.random()}
                  text={i}
                  onChange={(e) => {
                    handleChangeItem(i);
                  }}
                />
              ))}
          </div>

          <div>
            <Button>Salvar</Button>
          </div>
        </S.Form>
      </S.Wrapper>
    </S.Container>
  );
};
